import * as React from 'react';

interface IProps {
    isEventPage: boolean;
    logoUrl: string;
    chapterHomeUrl: string;
}

export function ChapterLogo({
    isEventPage,
    logoUrl,
    chapterHomeUrl
}: IProps) {

    if (!isEventPage || !logoUrl) {
        return null;
    }

    return (
        <div className='chapter-logo'>
            {chapterHomeUrl ? (
                <a href={chapterHomeUrl}>
                    <img src={logoUrl} />
                </a>
            ) : (
                <img src={logoUrl} />
            )}
        </div>
    );
};
